export default "__VITE_ASSET__5187604f__"